import type { LadderReference } from '../SpreadsTotals/ReferenceFloater';
import { classifyLineAvailability } from '@/lib/sport/lineAvailability';
import type { UserOrderSlice } from '@/hooks/useUserKalshiPOS';
import type { VenueBook, TeamSide } from '../ValueDashboard/types';
import type { GameRowsProps } from '../ValueDashboard/GameTable';
import { TwoSidedLadderBody } from '../SpreadsTotals/TwoSidedLadder';
import { bookForDisplayOnly } from '@/lib/market/bookDisplay';

/** An exact single derivative contract, both outcomes, separately labelled venues. */
export function DualOutcomeBooks({ reference, kalshi, polymarket, orders, makerRebatePct, onTrade, gameKey, teamSide }: {
  reference?: LadderReference;
  kalshi: VenueBook | null; polymarket: VenueBook | null; orders: UserOrderSlice[];
  makerRebatePct: number; onTrade: GameRowsProps['onTradeClick']; gameKey: string; teamSide: TeamSide;
}) {
  return <div className="w-0 min-w-full overflow-x-auto px-2 py-2" data-dual-outcome-books="">
    <div className="mb-1 text-xs text-muted-foreground">YES and NO · five bids and five asks per book · scroll horizontally if needed</div>
    <div className="flex gap-4">
      {(['kalshi', 'polymarket'] as const).map(venue => {
        const book = venue === 'kalshi' ? kalshi : polymarket;
        const displayBook = bookForDisplayOnly(book);
        return <section key={venue} className={reference ? "min-w-[30rem] flex-1" : "min-w-[26rem] flex-1"} aria-label={`${venue} YES and NO book`}>
          <h4 className="mb-1 text-xs font-semibold uppercase">{venue === 'kalshi' ? 'Kalshi' : 'Polymarket'}
            {book?.bookSourceValidity === 'unconfirmed' && <span className="ml-2 font-normal normal-case text-amber-400">
              {book.retainedDepth ? 'Last confirmed book' : 'Awaiting book'}</span>}
          </h4>
          {reference && venue === 'kalshi' && <div className="mb-1 text-xs font-mono">Pinnacle {reference.fair?.anchorUpdatedAtMs != null && Number.isFinite(reference.fair.anchorUpdatedAtMs) && Math.abs(reference.fair.anchorUpdatedAtMs) <= 8.64e15
            ? new Date(reference.fair.anchorUpdatedAtMs).toISOString().replace('T', ' ').replace('Z', ' UTC') : 'time unavailable'}</div>}
          <TwoSidedLadderBody kalshi={displayBook} venue={venue} reference={venue === 'kalshi' && !book?.retainedDepth ? reference : undefined} yesLabel="YES" noLabel="NO"
            availability={book?.bookSourceValidity === 'unconfirmed' ? 'stale' : classifyLineAvailability(book)} makerRebatePct={venue === 'kalshi' ? makerRebatePct : 0}
            userOrders={venue === 'kalshi' ? orders : null} presentation={{ depth: 5, layout: 'narrow' }}
            onLevelClick={(side, kind, cents) => {
              if (book?.bookSourceValidity === 'unconfirmed') return;
              onTrade?.(gameKey, teamSide, venue,
                { initialOrderSide: side, priceCents: cents, postOnly: kind === 'bid' });
            }} />
        </section>;
      })}
    </div>
  </div>;
}
